import React from "react";

import { Stack } from "@/components/ui";
import { cn } from "@/utils/cn";

interface PlaceholderAvatarProps {
  size: number;
  withText?: boolean;
  className?: string;
}

/** Fake avatar to display while data is loading. */
const PlaceholderAvatar: React.FC<PlaceholderAvatarProps> = ({
  size,
  withText = false,
  className,
}) => {
  const style = React.useMemo(() => {
    if (!size) {
      return {};
    }

    return {
      width: `${size}px`,
      height: `${size}px`,
    };
  }, [size]);

  return (
    <Stack space={2} className={cn("animate-pulse text-center", className)}>
      <div
        className="mx-auto block rounded-full bg-placeholder"
        style={style}
      />

      {withText && (
        <div
          style={{ width: size, height: 15 }}
          className="mx-auto rounded-full bg-placeholder"
        />
      )}
    </Stack>
  );
};

export default PlaceholderAvatar;
